import React from 'react';
import moment from 'moment';
import { Col, Row, Table } from 'react-bootstrap';
import logo from '../../../../assets/unhcr-logo-blue.png';
import { useAuth } from '../../../../contexts/AuthContext';
import { usePartnerStockReceive } from '../ContextAPI';

function ComponentToPrint(props, ref) {
    const { pdfData } = usePartnerStockReceive();
    const { auth } = useAuth();
    const headerCellStyle = { border: '1px solid #dee2e6' };

    const monthList = [
        '',
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    const monthName = monthList[Number(pdfData?.month)] || '';

    return (
        <fieldset ref={ref} className="customFieldset p-5">
            <Row className="mb-0">
                <Col>
                    <Table
                        bordered
                        className="mb-0"
                        style={{ borderCollapse: 'collapse', border: '1px solid #dee2e6' }}
                    >
                        <tbody>
                            <tr>
                                <td
                                    width="33%"
                                    className="text-center align-middle"
                                    style={headerCellStyle}
                                >
                                    <img width="120px" src={logo} alt="UNHCR Logo" />
                                </td>
                                <td
                                    width="34%"
                                    className="text-center align-middle"
                                    style={headerCellStyle}
                                >
                                    <h6 className="mb-0">Goods Receiving Notes</h6>
                                    <h6 className="mb-0">(GRN)</h6>

                                </td>
                                <td
                                    width="33%"
                                    className="text-center align-middle"
                                    style={headerCellStyle}
                                >
                                    {/* <h6 className="mb-0">NGO FORUM</h6>
                                    <small>FOR PUBLIC HEALTH</small> */}
                                    <h6 className="mb-0 d-none">NGO FORUM</h6>
                                    <small className='d-none'>FOR PUBLIC HEALTH</small>
                                </td>
                            </tr>
                            <tr>
                                <td width="25%" style={headerCellStyle}>
                                    <b>Partner</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>{pdfData?.partner_name}</td>
                                <td width="25%" style={headerCellStyle}>
                                    <b>GRN Number</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>{pdfData?.grn_no || pdfData?.grn_number || ''}</td>
                            </tr>
                            <tr>
                                <td width="25%" style={headerCellStyle}>
                                    <b>Year</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>{pdfData?.year}</td>
                                <td width="25%" style={headerCellStyle}>
                                    <b>Prepared By</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>
                                    {auth.employee_info
                                        ? `${auth.employee_info.first_name} ${auth.employee_info.last_name}`
                                        : auth.users?.username}
                                </td>
                            </tr>
                            <tr>
                                <td width="25%" style={headerCellStyle}>
                                
                                    <b>Month</b>
                                </td>
                                <td width="25%" style={headerCellStyle}>
                                    {monthName}
                                </td>
                                <td width="25%" style={headerCellStyle}> </td>
                                <td width="25%" style={headerCellStyle}> </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>

            <Row className="mb-0">
                <Col>
                    <Table striped bordered hover className="mb-0">
                        <thead>
                            <tr>
                                <th>SL</th>
                                <th>Item Name</th>
                                <th>Expiry Date</th>
                                <th>Approved Qty</th>
                                <th>Supplied Qty</th>
                                <th>Received Qty</th>
                                <th>Rejected Qty</th>
                                <th>Rejected Reason</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pdfData?.records?.map((el, index) => (
                                <tr key={Math.random()}>
                                    <td>{index + 1}</td>
                                    <td>{el.drug_name}</td>
                                    <td>
                                        {el.earliest_expire_date
                                            ? moment(el.earliest_expire_date).format('DD MMM YYYY')
                                            : ''}
                                    </td>
                                    <td>{el.approved_request_qty}</td>
                                    <td>{el.approved_supply_qty}</td>
                                    <td>{el.receive_qty}</td>
                                    <td>{el.rejected_qty}</td>
                                    <td>{el.rejected_reason}</td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </Col>
            </Row>

            <Row className="mb-0">
                <Col>
                    <Table bordered className="mb-0">
                        <tbody>
                            <tr>
                                <td width="33%"> </td>
                                <td width="33%">
                                    <b>Prepared by: (Receiver)</b>
                                </td>
                                <td width="34%">
                                    <b>Acknowledged by: (Supplier Representative / Driver)</b>
                                </td>
                            </tr>
                            <tr>
                                <td width="33%">Signature with date</td>
                                <td width="33%" height="80px"> </td>
                                <td width="34%" height="80px"> </td>
                            </tr>
                            <tr>
                                <td width="33%">Name</td>
                                <td width="33%"> </td>
                                <td width="34%"> </td>
                            </tr>
                            <tr>
                                <td width="33%">Designation</td>
                                <td width="33%"> </td>
                                <td width="34%"> </td>
                            </tr>
                        </tbody>
                    </Table>
                </Col>
            </Row>
        </fieldset>
    );
}

const forwardedInput = React.forwardRef(ComponentToPrint);

export default forwardedInput;
